export const generalConstants = {

  API_KEY: 'sowswo0gwk8g8oo8gws4cgg0c84cccso8w8k0g4k',
  BASE_URL: 'https://jobdesindo.com/',
  URL : '/',

  SETTING_REQUEST: 'GENERAL_SETTING_REQUEST',
  SETTING_SUCCESS: 'GENERAL_SETTING_SUCCESS',
  SETTING_FAILURE: 'GENERAL_SETTING_FAILURE',

  CONTENT_REQUEST: 'GENERAL_CONTENT_REQUEST',
  CONTENT_SUCCESS: 'GENERAL_CONTENT_SUCCESS',
  CONTENT_FAILURE: 'GENERAL_CONTENT_FAILURE',

  SUBCONTENT_REQUEST: 'GENERAL_SUBCONTENT_REQUEST',
  SUBCONTENT_SUCCESS: 'GENERAL_SUBCONTENT_SUCCESS',
  SUBCONTENT_FAILURE: 'GENERAL_SUBCONTENT_FAILURE',

  POST_CONTENT_REQUEST: 'GENERAL_POST_CONTENT_REQUEST',
  POST_CONTENT_SUCCESS: 'GENERAL_POST_CONTENT_SUCCESS',
  POST_CONTENT_FAILURE: 'GENERAL_POST_CONTENT_FAILURE',

  PUT_CONTENT_REQUEST: 'GENERAL_PUT_CONTENT_REQUEST',
  PUT_CONTENT_SUCCESS: 'GENERAL_PUT_CONTENT_SUCCESS',
  PUT_CONTENT_FAILURE: 'GENERAL_PUT_CONTENT_FAILURE',

  DELETE_CONTENT_REQUEST: 'GENERAL_DELETE_CONTENT_REQUEST',
  DELETE_CONTENT_SUCCESS: 'GENERAL_DELETE_CONTENT_SUCCESS',
  DELETE_CONTENT_FAILURE: 'GENERAL_DELETE_CONTENT_FAILURE',

  UPLOAD_REQUEST: 'GENERAL_UPLOAD_REQUEST',
  UPLOAD_SUCCESS: 'GENERAL_UPLOAD_SUCCESS',
  UPLOAD_FAILURE: 'GENERAL_UPLOAD_FAILURE',
  UPLOAD_SAVED: 'GENERAL_UPLOAD_SAVED',
  UPLOAD_CLEARED: 'GENERAL_UPLOAD_CLEARED',

  NOTIFICATION_REQUEST: 'GENERAL_NOTIFICATION_REQUEST',
  NOTIFICATION_SUCCESS: 'GENERAL_NOTIFICATION_SUCCESS',
  NOTIFICATION_FAILURE: 'GENERAL_NOTIFICATION_FAILURE',

  POST_FILES_REQUEST: 'GENERAL_POST_FILES_REQUEST',
  POST_FILES_SUCCESS: 'GENERAL_POST_FILES_SUCCESS',
  POST_FILES_FAILURE: 'GENERAL_POST_FILES_FAILURE',

  FILES_REQUEST: 'GENERAL_FILES_REQUEST',
  FILES_SUCCESS: 'GENERAL_FILES_SUCCESS',
  FILES_FAILURE: 'GENERAL_FILES_FAILURE'
};



// WEBPACK FOOTER //
// ./src/constants/general.constants.js